<template>
  <v-container my-5>
    <v-layout justify-center>
      <v-flex xs4 mx-3 highlight>
        <p class="my-3 headline text-xs-center">Free</p>
        <v-layout wrap pa-3 white ma-1 style="height: 360px">
          <v-flex xs12 text-xs-center py-3 body-2>
            A different manipulative each<br/>week
          </v-flex>
          <v-flex xs12 text-xs-center headline font-weight-bold py-3 secondary--text>
            $0
          </v-flex>
          <v-flex xs12 style="height:140px">
            <ul style="list-style: url('checkmark.png');">
              <li style="padding: 4px 0;">1 rotating manipulative</li>
              <li style="padding: 4px 0;">Access on any device</li>
              <li style="padding: 4px 0;">Use at school and home</li>
              <li style="padding: 4px 0;">Interactive whiteboard compatible</li>
            </ul>
          </v-flex>
          <v-flex xs12 text-xs-center style="height:50px">
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs4 mx-3 highlight>
        <p class="my-3 headline text-xs-center">School</p>
        <v-layout wrap pa-3 white ma-1 style="height: 360px">
          <v-flex xs12 text-xs-center py-3 body-2>
            All 15 manipulatives, for entire campus
          </v-flex>
          <v-flex xs12 text-xs-center headline font-weight-bold py-3 secondary--text>
            $495 /yr
          </v-flex>
          <v-flex xs12 style="height:140px">
            <ul style="list-style: url('checkmark.png');">
              <li style="padding: 4px 0;">All 15 manipulatives</li>
              <li style="padding: 4px 0;">Access on any device</li>
              <li style="padding: 4px 0;">Use at school and home</li>
              <li style="padding: 4px 0;">Interactive whiteboard compatible</li>
            </ul>
          </v-flex>
          <v-flex xs12 text-xs-center style="height:50px">
            <v-btn
              round
              color="accent"
              href="order-form.pdf"
              target="_blank"
            >
              Select
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-5>
      <v-flex xs12 ma-0 pa-0 text-xs-center headline font-weight-bold>
        <p>Questions?</p>
      </v-flex>
      <v-flex xs12 ma-0 pa-0 text-xs-center title font-weight-light>
        <p>Call 888.967.2267 or email <a style="color: #0089a6" href="mailto:sales@brainingcamp.com">sales@brainingcamp.com</a></p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>

